(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facilities"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobileQuery = window.matchMedia('(max-width: 768px)');

    function initFacilities(root) {
      var track = root.querySelector('.facilities__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.facilities__slide'));
      var prevBtn = root.querySelector('.facilities__arrow--prev');
      var nextBtn = root.querySelector('.facilities__arrow--next');
      var count = slides.length;
      if (!count) return;

      function currentIndex() {
        var slideWidth =
          slides[0].offsetWidth + parseFloat(getComputedStyle(track).rowGap || getComputedStyle(track).gap || 0);
        return Math.round(track.scrollLeft / slideWidth);
      }

      function goTo(index) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      }

      function step(direction) {
        var index = currentIndex();

        if (mobileQuery.matches) {
          index = (index + direction + count) % count;
        } else {
          index = Math.max(0, Math.min(count - 1, index + direction));
        }

        goTo(index);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          step(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          step(1);
        });
      }
    }

    document.querySelectorAll('[data-section-type="facilities"]').forEach(initFacilities);

    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target.querySelector('[data-section-type="facilities"]');
      if (root) initFacilities(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hosted-events"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initHostedEvents(root) {
      var track = root.querySelector('.hosted-events__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.hosted-events__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.hosted-events__dot'));
      var prevBtn = root.querySelector('.hosted-events__arrow--prev');
      var nextBtn = root.querySelector('.hosted-events__arrow--next');
      var count = slides.length;
      if (!count) return;

      function currentIndex() {
        var slideWidth = slides[0].offsetWidth;
        if (!slideWidth) return 0;
        return Math.round(track.scrollLeft / slideWidth);
      }

      function goTo(index) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });
      }

      function updateDots() {
        var index = Math.max(0, Math.min(count - 1, currentIndex()));
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-selected', i === index);
        });
      }

      function step(direction) {
        var index = (currentIndex() + direction + count) % count;
        goTo(index);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() { step(-1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() { step(1); });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.index, 10));
        });
      });

      var scrollTimeout;
      track.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateDots, 100);
      }, { passive: true });
    }

    document.querySelectorAll('[data-section-type="hosted-events"]').forEach(initHostedEvents);

    document.addEventListener('shopify:section:load', function(evt) {
      var root = evt.target.querySelector('[data-section-type="hosted-events"]');
      if (root) initHostedEvents(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-contact"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var duration = 250;
    var easing = 'ease';

    function initAccordion(root) {
      var items = root.querySelectorAll('.info-contact__accordion-item');

      items.forEach(function(details) {
        var summary = details.querySelector('.info-contact__accordion-trigger');
        var content = details.querySelector('.info-contact__accordion-content');
        if (!summary || !content) return;

        var animation = null;

        summary.addEventListener('click', function(evt) {
          evt.preventDefault();
          details.style.overflow = 'hidden';
          if (details.open) {
            details.classList.remove('is-open');
            shrink();
          } else {
            details.classList.add('is-open');
            expand();
          }
        });

        function boxExtra() {
          var style = window.getComputedStyle(details);
          return parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        }

        function shrink() {
          var startHeight = details.offsetHeight + 'px';
          var endHeight = (summary.offsetHeight + boxExtra()) + 'px';
          if (animation) animation.cancel();
          animation = details.animate({ height: [startHeight, endHeight] }, { duration: duration, easing: easing });
          animation.onfinish = function() { onFinish(false); };
        }

        function expand() {
          details.style.height = details.offsetHeight + 'px';
          details.open = true;
          window.requestAnimationFrame(function() {
            var startHeight = details.offsetHeight + 'px';
            var endHeight = (summary.offsetHeight + content.offsetHeight + boxExtra()) + 'px';
            if (animation) animation.cancel();
            animation = details.animate({ height: [startHeight, endHeight] }, { duration: duration, easing: easing });
            animation.onfinish = function() { onFinish(true); };
          });
        }

        function onFinish(open) {
          details.open = open;
          animation = null;
          details.style.height = '';
          details.style.overflow = '';
        }
      });
    }

    function initShowMore(root) {
      var accordion = root.querySelector('[data-accordion]');
      var button = root.querySelector('[data-show-more]');
      if (!accordion || !button || accordion.dataset.loadMore !== 'true') return;

      var perPage = parseInt(accordion.dataset.perPage, 10) || 4;

      function update() {
        button.hidden = accordion.querySelectorAll('.info-contact__accordion-item.is-hidden').length === 0;
      }

      function reveal(item, delay) {
        item.classList.remove('is-hidden');
        var naturalHeight = item.offsetHeight;
        item.style.overflow = 'hidden';
        item.style.height = '0px';
        item.style.opacity = '0';
        item.offsetHeight;
        var animation = item.animate(
          [
            { height: '0px', opacity: 0 },
            { height: naturalHeight + 'px', opacity: 1 }
          ],
          { duration: duration, easing: easing, delay: delay }
        );
        animation.onfinish = function() {
          item.style.height = '';
          item.style.overflow = '';
          item.style.opacity = '';
        };
      }

      button.addEventListener('click', function() {
        var hidden = Array.prototype.slice.call(accordion.querySelectorAll('.info-contact__accordion-item.is-hidden'));
        hidden.slice(0, perPage).forEach(function(item, index) {
          reveal(item, index * 60);
        });
        update();
      });

      update();
    }

    function init(root) {
      initAccordion(root);
      initShowMore(root);
    }

    document.querySelectorAll('[data-section-type="info-contact"]').forEach(init);

    document.addEventListener('shopify:section:load', function(evt) {
      var root = evt.target.querySelector('[data-section-type="info-contact"]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var duration = 250;
    var easing = 'ease';

    function initAccordion(root) {
      var items = root.querySelectorAll('.info-faq__accordion-item');

      items.forEach(function(details) {
        var summary = details.querySelector('.info-faq__accordion-trigger');
        var content = details.querySelector('.info-faq__accordion-content');
        if (!summary || !content) return;

        var animation = null;

        summary.addEventListener('click', function(evt) {
          evt.preventDefault();
          details.style.overflow = 'hidden';
          if (details.open) {
            details.classList.remove('is-open');
            shrink();
          } else {
            details.classList.add('is-open');
            expand();
          }
        });

        function boxExtra() {
          var style = window.getComputedStyle(details);
          return parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        }

        function shrink() {
          var startHeight = details.offsetHeight + 'px';
          var endHeight = (summary.offsetHeight + boxExtra()) + 'px';
          if (animation) animation.cancel();
          animation = details.animate({ height: [startHeight, endHeight] }, { duration: duration, easing: easing });
          animation.onfinish = function() { onFinish(false); };
        }

        function expand() {
          details.style.height = details.offsetHeight + 'px';
          details.open = true;
          window.requestAnimationFrame(function() {
            var startHeight = details.offsetHeight + 'px';
            var endHeight = (summary.offsetHeight + content.offsetHeight + boxExtra()) + 'px';
            if (animation) animation.cancel();
            animation = details.animate({ height: [startHeight, endHeight] }, { duration: duration, easing: easing });
            animation.onfinish = function() { onFinish(true); };
          });
        }

        function onFinish(open) {
          details.open = open;
          animation = null;
          details.style.height = '';
          details.style.overflow = '';
        }
      });
    }

    function initShowMore(root) {
      var accordion = root.querySelector('[data-accordion]');
      var button = root.querySelector('[data-show-more]');
      if (!accordion || !button || accordion.dataset.loadMore !== 'true') return;

      var perPage = parseInt(accordion.dataset.perPage, 10) || 4;

      function update() {
        button.hidden = accordion.querySelectorAll('.info-faq__accordion-item.is-hidden').length === 0;
      }

      function reveal(item, delay) {
        item.classList.remove('is-hidden');
        var naturalHeight = item.offsetHeight;
        item.style.overflow = 'hidden';
        item.style.height = '0px';
        item.style.opacity = '0';
        item.offsetHeight;
        var animation = item.animate(
          [
            { height: '0px', opacity: 0 },
            { height: naturalHeight + 'px', opacity: 1 }
          ],
          { duration: duration, easing: easing, delay: delay }
        );
        animation.onfinish = function() {
          item.style.height = '';
          item.style.overflow = '';
          item.style.opacity = '';
        };
      }

      button.addEventListener('click', function() {
        var hidden = Array.prototype.slice.call(accordion.querySelectorAll('.info-faq__accordion-item.is-hidden'));
        hidden.slice(0, perPage).forEach(function(item, index) {
          reveal(item, index * 60);
        });
        update();
      });

      update();
    }

    function init(root) {
      initAccordion(root);
      initShowMore(root);
    }

    document.querySelectorAll('[data-section-type="info-faq"]').forEach(init);

    document.addEventListener('shopify:section:load', function(evt) {
      var root = evt.target.querySelector('[data-section-type="info-faq"]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTestimonialsSlider(root) {
      var track = root.querySelector('.testimonials-slider__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.testimonials-slider__slide'));
      var prevBtn = root.querySelector('.testimonials-slider__arrow--prev');
      var nextBtn = root.querySelector('.testimonials-slider__arrow--next');
      var dots = Array.prototype.slice.call(root.querySelectorAll('.testimonials-slider__dot'));
      var count = slides.length;
      if (!count) return;

      function currentIndex() {
        var slideWidth = slides[0].offsetWidth;
        if (!slideWidth) return 0;
        return Math.round(track.scrollLeft / slideWidth);
      }

      function goTo(index) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });
      }

      function updateDots() {
        var index = Math.max(0, Math.min(count - 1, currentIndex()));
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-selected', i === index);
        });
      }

      function step(direction) {
        var index = (currentIndex() + direction + count) % count;
        goTo(index);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() { step(-1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() { step(1); });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.index, 10));
        });
      });

      var scrollTimeout;
      track.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateDots, 100);
      }, { passive: true });
    }

    document.querySelectorAll('[data-section-type="testimonials-slider"]').forEach(initTestimonialsSlider);

    document.addEventListener('shopify:section:load', function(evt) {
      var root = evt.target.querySelector('[data-section-type="testimonials-slider"]');
      if (root) initTestimonialsSlider(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venue-spaces"] && !Shopify.designMode) return;
  try {
    
(function() {
  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function initVenueSpaces(root) {
    var track = root.querySelector('.venue-spaces__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.venue-spaces__slide'));
    var prevBtn = root.querySelector('.venue-spaces__arrow--prev');
    var nextBtn = root.querySelector('.venue-spaces__arrow--next');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.venue-spaces__dot'));
    var count = slides.length;
    if (!count) return;

    var touchStartX = 0;
    var touchEndX = 0;
    var isScrolling = false;

    function getSlideWidth() {
      return slides[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
    }

    function currentIndex() {
      return Math.round(track.scrollLeft / getSlideWidth());
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      isScrolling = true;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
      setTimeout(function() {
        isScrolling = false;
      }, 600);
    }

    function updateDots() {
      var index = Math.max(0, Math.min(count - 1, currentIndex()));
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-selected', i === index);
      });
    }

    function step(direction) {
      if (isScrolling) return;
      
      var index = currentIndex();

      if (mobileQuery.matches) {
        index = (index + direction + count) % count;
      } else {
        index = Math.max(0, Math.min(count - 1, index + direction));
      }

      goTo(index);
    }

    function handleSwipe() {
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        step(diff > 0 ? 1 : -1);
      }
    }

    // Touch swipe events
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
    }, false);

    track.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].clientX;
      handleSwipe();
    }, false);

    // Click handlers
    if (prevBtn) {
      prevBtn.addEventListener('click', function() { step(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() { step(1); });
    }

    // Dot click handlers
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    // Scroll event for dot updates
    var scrollTimeout;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateDots, 100);
    }, { passive: true });
  }

  document.querySelectorAll('[data-section-type="venue-spaces"]').forEach(initVenueSpaces);

  document.addEventListener('shopify:section:load', function(evt) {
    var root = evt.target.querySelector('[data-section-type="venue-spaces"]');
    if (root) initVenueSpaces(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
